import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition,
	OptionType
} from '@evinced-private/ui-common';

const searchFilter: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {
		className: 'search-filter'
	}
};

const severitiesFilter: ISelectFilterDefinition = {
	id: 'severities',
	label: 'Severity',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select Severity',
		allSelectedPlaceholder: 'All Severities',
		someItemsSelectedText: (numberOfItems: number) => `Severities (${numberOfItems})`,
		isMultiple: true,
		id: 'severities',
		label: 'Severity',
		listboxWidth: '150px'
	}
};

const typesFilter: ISelectFilterDefinition = {
	id: 'types',
	label: 'Issue Type',
	filterType: 'select',
	defaultValue: [],
	componentProps: {
		placeholder: 'Select Issue Type',
		allSelectedPlaceholder: 'All Issue Types',
		someItemsSelectedText: (numberOfItems: number) => `Issue Types (${numberOfItems})`,
		isMultiple: true,
		id: 'types',
		label: 'Issue Type',
		listboxWidth: '150px'
	}
};

export const getMfaSingleSessionFilterDefinitions = (
	scansLoadOptions?: (searchText: string, callback: (options: OptionType[]) => void) => void,
	scansOptions?: OptionType[]
): IFilterDefinition[] => {
	const scansFilter: ISelectFilterDefinition = {
		id: 'scans',
		label: 'Scans',
		filterType: 'select',
		defaultValue: [],
		componentProps: {
			placeholder: 'Select Scan',
			allSelectedPlaceholder: 'All Scans',
			someItemsSelectedText: (numberOfItems: number) => `Scans (${numberOfItems})`,
			isMultiple: true,
			id: 'scans',
			label: 'Scan',
			listboxWidth: '150px',
			...(scansLoadOptions && { loadOptions: scansLoadOptions }),
			...(scansOptions && { options: scansOptions }),
			...(scansLoadOptions && { isSearchable: true })
		}
	};

	return [searchFilter, severitiesFilter, typesFilter, scansFilter];
};
